var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{ref:"content",tag:"component",on:{"click":function($event){return _vm.trackClick(_vm.item, _vm.index)}}},[(_vm.intersected)?_vm._t("default"):_vm._t("loading")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }